import { cn } from "@/lib/utils"

type EventDetailShellProps = {
  children: React.ReactNode
  /** Outer shell (max-width + clip). */
  className?: string
  /** Inner track: width constraint + min-w-0; use for flex/spacing (e.g. `space-y-6`, `flex flex-col items-center`). */
  contentClassName?: string
}

/**
 * Centered event experience column — same max width for public `/event`, `/invite`, preview, edit, and timeline open.
 * Horizontal inset comes from the parent `.app-shell` (`--spacing-page-x`); avoid extra max-width on event pages.
 */
export function EventDetailShell({
  children,
  className,
  contentClassName,
}: EventDetailShellProps) {
  return (
    <div className={cn("event-detail-shell", className)}>
      <div className={cn("event-detail-shell-content", contentClassName)}>
        {children}
      </div>
    </div>
  )
}
